import { Box } from "@mui/material";

function PageNotFound() {
    return (
        <Box height="100%" width="100%">
            ERROR 404, PAGE NOT FOUND.
        </Box>
    );
}

export default PageNotFound;
